import React from 'react';
import Slider from 'react-slick';
import styled from 'styled-components';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import imagen1 from './1.jpg';
import imagen2 from './2.jpg';
import imagen3 from './3.jpg';
import imagen4 from './4.jpg';
import imagen5 from './5.jpg';
import imagen6 from './6.jpg';
import imagen7 from './7.jpg';
import imagen8 from './8.jpg';
import imagen9 from './9.jpg';
import imagen10 from './10.jpg';
import imagen11 from './11.jpg';
import imagen12 from './12.jpg';
import imagen13 from './13.jpg';


const Container = styled.div`
  margin: 70px auto;
  margin-bottom: 0px;
  max-width: 80%;

  @media (max-width: 767px) {
    max-width: 95%;
  }
`;

const SliderContainer = styled.div`
  margin: 0 auto;
  max-width: 100%;
  height: 400px;
`;



const Image = styled.img`
  width: 100%;
  height: 400px;
  object-fit: cover;
  margin: 0 auto;
`;

const Carrusel = () => {
  const images = [imagen1, imagen2, imagen3, imagen4, imagen5, imagen6, imagen7, imagen8, imagen9, imagen10, imagen11, imagen12, imagen13];

  const settings = {
    dots: false, // Desactiva los puntos
    arrows: true, // Activa las flechas
    infinite: true,
    speed: 1500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3500,
    pauseOnHover: false,
  };


  return (
    <Container>
      <SliderContainer>
        <Slider {...settings}>
          {images.map((image, index) => (
            <div key={index}>
              <Image src={image} alt={`Imagen ${index + 1}`} />
            </div>
          ))}
        </Slider>
      </SliderContainer>
      <style>
        {`
          .slick-prev, .slick-next {
            color: transparent; /* Hace el texto transparente */
          }
          .slick-prev:before, .slick-next:before {
            font-size: 20px; /* Ajusta el tamaño de las flechas */
            color: grey; /* Cambia el color de las flechas */
            opacity: 0.75; /* Ajusta la opacidad para una mejor visibilidad */
          }
          /* Estilos para el hover */
          .slick-prev:hover:before, .slick-next:hover:before {
            color: darkgrey;
            opacity: 1;
          }
        `}
      </style>
    </Container>
  );
};

export default Carrusel;